import { render, staticRenderFns } from "./conversation-container.vue?vue&type=template&id=0bc74eba&"
import script from "./conversation-container.vue?vue&type=script&lang=js&"
export * from "./conversation-container.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports